module.exports = __webpack_public_path__ + "static/media/pattern.6329fa98.svg";